// validations.js
const validators = {
  required: (value, label) => (!value ? `${label} is required` : null),
};

export default validators;
